import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { comnUtils, comnEnvs } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button, FormControl } from "@/comn/components"; // 화면 구성 컴포넌트
import { useForm, useFetch, useResource, useGrid, useModal, useStore, useToast, usePopup, usePage } from "@/comn/hooks"; // hook
import {
    BASE,
    URLS,
    APIS,
    SF_TODO_SRCH,
    SG_TODO_LIST,
} from "@/tz/go/egaz/osci/ptl/mypg/todo/services/OsciMyTodoService";

/*
 * Customs Management List
 * !== 나의 할일 목록 ==!
 */
export const OSCI0102001Q = (): JSX.Element => {
    const { pgeUid, menuId } = usePage();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast();
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    useResource({
        defaultSchema: [{ area: "comnCd", comnCd: "OSC0099" }],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Search for my tasks !== 나의 할일 검색 ==!
        todoSrch: useForm({
            defaultSchema: SF_TODO_SRCH,
            defaultValues: {
                todoPrcdStatCd: "R",
                ...(pgeStore?.form || {}),
                frstRgsrDtmFrom: comnUtils.getDate({ m: -1 }),
                frstRgsrDtmTo: comnUtils.getDate(),
            },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // My to-do List !== 나의 할일 목록 ==!
        todoList: useGrid({
            defaultSchema: SG_TODO_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        // View my to-do list !== 나의 할일 목록 조회 ==!
        getTodoList: useFetch({
            api: (page = grid.todoList.page) => {
                return APIS.getTodoList(form.todoSrch.getValues(), page, grid.todoList.size);
            },
            enabled: comnUtils.isEmpty(form.todoSrch.errors) && form.todoSrch.isSubmitted,
            key: [grid.todoList.page, grid.todoList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.todoSrch.getValues(),
                    page: grid.todoList.page,
                    size: grid.todoList.size,
                });
            },
            onError: () => {},
            showToast: true,
        }),

        // To Do Task Category COMBO View !== 할일 업무 구분 COMBO 조회 ==!
        getTodoBsopTpList: useFetch({
            api: () => {
                return APIS.getTodoBsopTpList();
            },
            onSuccess: (data) => {
                form.todoSrch.setSchema("scrnDocCd", {
                    options: data.todoBsopDvnList.content.map((item: any, index: number) => ({
                        label: item.todoBsopDvn,
                        value: item.scrnDocCd,
                    })),
                });
            },
            onError: () => {},
            showToast: true,
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // View my to-do list !== 나의 할일 목록 조회 ==!
        getTodoList: () => {
            form.todoSrch.handleSubmit(
                (data) => {
                    grid.todoList.setPage(0);
                    fetch.getTodoList.fetch(0);
                },
                (data) => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" });
                },
            )();
        },
        // To Do Task Category COMBO View !== 할일 업무 구분 COMBO 조회 ==!
        getTodoBsopTpList: () => {
            fetch.getTodoBsopTpList.fetch(0);
        },
        grid_TodoDtl: (props: any) => {
            const { rowValues, value } = props;
            if (rowValues.todoReffId !== null) {
                if (rowValues.todoReffId.charAt(0) !== "/") {
                    rowValues.todoReffId = "/" + rowValues.todoReffId;
                }
            }
            const scrnDocUrlAddr = rowValues.scrnDocUrlAddr + rowValues.todoReffId;

            let frontDmn;
            const getBsopClsfCd = rowValues.bsopClsfCd;
            frontDmn = process.env.REACT_APP_API_FRONT_OSCI;

            console.log(scrnDocUrlAddr + " : " + rowValues.ptlTodoPrcdStatCd);

            console.log(`${frontDmn}${scrnDocUrlAddr}?menuId=mytodo&ptlTodoPrcdStatCd=${rowValues.ptlTodoPrcdStatCd}`);
            console.log(`${frontDmn}${scrnDocUrlAddr}&menuId=mytodo&ptlTodoPrcdStatCd=${rowValues.ptlTodoPrcdStatCd}`);

            // 추후 삭제 할 것 (도메인 동일함)
            rowValues.todoReffId.indexOf("?") === -1
                ? window.open(
                      `${frontDmn}${scrnDocUrlAddr}?menuId=mytodo&ptlTodoPrcdStatCd=${rowValues.ptlTodoPrcdStatCd}`,
                      "_parent",
                  )
                : window.open(
                      `${frontDmn}${scrnDocUrlAddr}&menuId=mytodo&ptlTodoPrcdStatCd=${rowValues.ptlTodoPrcdStatCd}`,
                      "_parent",
                  );
        },
    };

    /*
     * Declaration Event Render
     * !== 랜더 정의 ==!
     */
    const render = {
        grid_todoList: {
            cell: {
                todoReffId: (props: any) => {
                    const { rowValues, value } = props;
                    return (
                        <Link
                            to={"#"}
                            onClick={(e) => {
                                e.preventDefault();
                                handler.grid_TodoDtl(props);
                            }}
                        >
                            {value}
                        </Link>
                    );
                },
            },
        },
    };

    useEffect(() => {
        handler.getTodoBsopTpList();
        handler.getTodoList();
    }, []);

    return (
        <Page>
            <form>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.todoSrch.schema.frstRgsrDtm}></Group.Control>
                                <Group.Control {...form.todoSrch.schema.todoReffId}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.todoSrch.schema.scrnDocCd} all={true}></Group.Control>
                                <Group.Control {...form.todoSrch.schema.todoPrcdStatCd} all={true}></Group.Control>
                            </Group.Row>
                        </Group.Section>
                        <Layout direction="row">
                            <Layout.Left>
                                <Button
                                    role={"reset"}
                                    onClick={() => {
                                        form.todoSrch.reset();
                                    }}
                                >
                                    {t("B_RESET")}
                                </Button>
                            </Layout.Left>
                            <Layout.Right>
                                <Button
                                    role={"search"}
                                    onClick={() => {
                                        handler.getTodoList();
                                    }}
                                >
                                    {t("B_SRCH")}
                                </Button>
                            </Layout.Right>
                        </Layout>
                    </Group.Body>
                </Group>
            </form>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid
                            {...grid.todoList.grid}
                            data={fetch.getTodoList.data?.todoList}
                            render={render.grid_todoList}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
